const messageTypes = {}
messageTypes.getIconType = function (type) {
  switch (type) {
    // Payment methods
    case 'TRANSACTION_PAYMENT_SMS_CAMPAIGN':
      return 'mdi-message-plus'
    case 'TRANSACTION_PAYMENT_EMAIL_CAMPAIGN':
      return 'mdi-mailbox-open'
    case 'TRANSACTION_PAYMENT_EVENT_TICKET_PURCHASE_CONFIRMATION':
      return 'local_play'
    case 'TRANSACTION_PAYMENT_EMAIL':
    case 'email':
      return 'mail_outline'
    case 'TRANSACTION_PAYMENT_SMS':
    case 'sms':
      return 'sms'
    case 'massive':
      return 'language'
    case 'push':
      return 'system_update'
    case 'whatsapp':
      return 'fab fa-whatsapp'
    case 'request':
      return 'cloud_upload'
    default:
      return 'indeterminate_check_box'
  }
}
export default messageTypes
